import { render } from "./InstallView.vue?vue&type=template&id=1533206e"
import script from "./InstallView.vue?vue&type=script&lang=js"
export * from "./InstallView.vue?vue&type=script&lang=js"

import "./InstallView.vue?vue&type=style&index=0&id=1533206e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__